import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { useAuth } from '../context/AuthContext';

function Notificaciones() {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const orgId = profile?.organization_id;

  const [alertas, setAlertas] = useState([]);

  useEffect(() => {
    const check = async () => {
      if (!orgId) return;

      const nuevos = [];

      // 1) Pedidos web pendientes
      const { data: pendingSales } = await supabase
        .from('sales')
        .select('id, total, status, billing_source, client_id, clients:client_id (full_name)')
        .eq('organization_id', orgId)
        .eq('billing_source', 'PORTAL_WEB')
        .ilike('status', '%pending%');

      (pendingSales || []).forEach(p => {
        nuevos.push({
          tipo: 'pedido',
          msg: `Nuevo pedido web de ${p.clients?.full_name || 'Cliente'} ($${Number(p.total || 0).toLocaleString('es-AR')})`,
          link: `/sistema/pedidos-web/${p.id}`
        });
      });

      // 2) Stock bajo (simple: quantity <= min_stock por stock_levels)
      const { data: lowStock } = await supabase
        .from('stock_levels')
        .select('product_id, quantity, min_stock, products:product_id (name)')
        .eq('organization_id', orgId);

      (lowStock || [])
        .filter(s => Number(s.quantity || 0) <= Number(s.min_stock || 0))
        .forEach(s => {
          nuevos.push({
            tipo: 'stock',
            msg: `Stock crítico: ${s.products?.name || 'Producto'} (${Number(s.quantity || 0)} u.)`,
            link: `/sistema/productos`
          });
        });

      setAlertas(nuevos);
    };

    check();
  }, [orgId, navigate]);

  return (
    <div style={{ padding: 20 }}>
      <div className="header-bar"><h1>Centro de Notificaciones</h1></div>

      <div style={{ maxWidth: 650 }}>
        {alertas.length === 0 && (
          <div className="card" style={{ textAlign: 'center', color: '#999' }}>
            No hay notificaciones nuevas.
          </div>
        )}

        {alertas.map((a, i) => (
          <div
            key={i}
            className="card"
            style={{
              marginBottom: 15,
              cursor: 'pointer',
              borderLeft: `5px solid ${a.tipo === 'pedido' ? '#3b82f6' : '#ef4444'}`,
              display: 'flex',
              alignItems: 'center',
              gap: 15
            }}
            onClick={() => navigate(a.link)}
          >
            <div style={{ fontSize: 22, color: a.tipo === 'pedido' ? '#3b82f6' : '#ef4444' }}>
              {a.tipo === 'pedido' ? '🛒' : '⚠️'}
            </div>
            <div>
              <strong>{a.tipo === 'pedido' ? 'Nuevo Pedido Web' : 'Alerta de Stock'}</strong>
              <div style={{ color: '#666' }}>{a.msg}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Notificaciones;
